import { render, staticRenderFns } from "./booking-general-information.vue?vue&type=template&id=954b991c"
import script from "./booking-general-information.vue?vue&type=script&lang=js"
export * from "./booking-general-information.vue?vue&type=script&lang=js"
import style0 from "./booking-general-information.vue?vue&type=style&index=0&id=954b991c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports